import { render } from "./Score.vue?vue&type=template&id=360c086a&ts=true"
import script from "./Score.vue?vue&type=script&lang=ts"
export * from "./Score.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__